'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('businessPlanModule')

    .factory('businessPlanExplorerService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/BusinessPlanExplorer';

    var service = {};

    // business Plan Explorer
    service.reIndex = function () {
        return $http
            .get(baseUrl + '/ReIndex')
            .then(function (response) { return response.data; });
    };

    return service;
}]);
